import React from "react";
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from "react-router-dom";
import Home from "./Home";
import Toegangskaarten from "./Toegangskaarten";

function Navbar() {
  const location = useLocation();
  if (location.pathname !== "/Toegangskaarten") return null;
  return (
    <nav className="navbar">
      <Link to="/">Home</Link>
      <Link to="/Toegangskaarten">Toegangskaarten</Link>
    </nav>
  );
}

const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Toegangskaarten" element={<Toegangskaarten />} />
      </Routes>
    </Router>
  );
};

export default App;
